// @flow

import React from 'react';
import type { Node } from 'react';
import { ACFRow } from '../row';
import type { ACFRow as ACFRowProps } from '../../types';

type Props = {
  rows: Array<{|
    ...ACFRowProps,
    sticky?: boolean,
  |}>,
};

const Rows = ({
  rows,
}: Props) => {
  if (!rows) return null;

  return rows.map<Node>((row, index) => (
    <ACFRow
      key={index} // eslint-disable-line react/no-array-index-key
      {...row}
    />
  ));
};

export default Rows;
